<template>
    <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper" >
            <swiper-slide v-for="(item,index) in banners" :key="index">
                <div class="item" :style="[{backgroundImage: `url(${item.img})`}]">
                    <div v-if="item.id == 1" class="banner_button">
                        <div id="free_experience" class="free_experience" @click="toOpen(2)">免费体验</div>
                        <div id="dow_win" class="win" @click="toOpen(1)"><img src="../../../static/images2/win.png" alt="">下载电脑客户端</div>
                    </div>
                    <div v-if="item.id == 3" class="banner_button">
                        <div id="registration" class="free_experience" @click="toApply">入驻申请</div>
                    </div>
                </div>
                <div class="functional main_width m_0 main_color">
                    <div :class="[handleInquiryIndex == 1 && 'middle_m']" v-for="(functionalItem, handleInquiryIndex) in item.child" :key="handleInquiryIndex">
                        <img :src="functionalItem.img" alt="">
                        <div>
                            <div class="functional_title">{{ functionalItem.title }}</div>
                            <div class="functional_des">{{ functionalItem.des }}</div>
                        </div>
                    </div>
                </div>
                <!-- h5  版本 -->
                <div class="functional_h5">
                    <div v-for="(functionalItem, handleInquiryIndex) in item.child" :key="handleInquiryIndex">
                        <img :src="functionalItem.img" alt="">
                        <div>{{ functionalItem.title }}</div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <modal v-model="showModal" title="" @confirm="onConfirm" @cancel="onCancel">
            <form class="main_color">
                <div class="form-group">
                    <label>您想合作的方向是？</label>
                    <!-- <input type="text" v-model="modalData.title" maxlength="100"></input> -->
                    <select v-model="modalData.title">
                        <option value="商城入驻"><div>商城入驻</div></option>
                        <option value="商务&数据合作">商务&数据合作</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>联系方式</label>
                    <input type="text" v-model="modalData.phone" maxlength="15"></input>
                </div>
                <div class="form-group">
                    <label>联系人</label>
                    <input type="text" v-model="modalData.username" maxlength="20"></input>
                </div>
            </form>
        </modal>
    </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import modal from '../../components/modal.vue';
import banner1 from '../../../static/images2/banner1.png'
import banner2 from '../../../static/images2/banner2.png'
import banner3 from '../../../static/images2/banner3.webp'
import vin from '../../../static/images2/vin.png'
import epc from '../../../static/images2/epc.png'
import goods from '../../../static/images2/goods.png'
import syncStok from '../../../static/images2/sync_stok.png'
import saas from '../../../static/images2/saas.png'
import phone from '../../../static/images2/phone.png'
import quality from '../../../static/images2/quality.png'
import personalization from '../../../static/images2/personalization.png'
import analysis from '../../../static/images2/analysis.png'


import H5banner1 from '../../../static/images2/h5/banner1.webp'
import H5banner2 from '../../../static/images2/h5/banner2.webp'
import H5banner3 from '../../../static/images2/h5/banner3.webp'
import { isMinView, onEventGsIdo } from '../../utils/index.js'
export default {
    components: {
        swiper,
        swiperSlide,
        modal
    },
    data() {
        return {
            banners: [
                {
                    id: 1,
                    img: isMinView() ? H5banner1 : banner1,
                    child: [
                        {
                            id: 1,
                            img: vin,
                            title: '车架号查车况',
                            des: '(配置详情、维保/出险记录等)'
                        },
                        {
                            id: 2,
                            img: epc,
                            title: '车辆配件查询',
                            des: '可视化查询品牌零件结构'
                        },
                        {
                            id: 3,
                            img: goods,
                            title: '7*24小时',
                            des: '线上配件担保交易平台'
                        }
                    ]
                },
                {
                    id: 2,
                    img: isMinView() ? H5banner2 : banner2,
                    child: [
                        {
                            id: 1,
                            img: syncStok,
                            title: '一键同步库存',
                            des: '提升周转率30%'
                        },
                        {
                            id: 2,
                            img: saas,
                            title: 'saas解决方案',
                            des: '服务10万+ b端付费会员'
                        },
                        {
                            id: 3,
                            img: phone,
                            title: '掌上快捷管理',
                            des: '随时随地了解货物最新动态'
                        }
                    ]
                },
                {
                    id: 3,
                    img: isMinView() ? H5banner3 : banner3,
                    child: [
                        {
                            id: 1,
                            img: quality,
                            title: '严选商家质量',
                            des: '超1000家品牌商家合作，严格把控质量'
                        },
                        {
                            id: 2,
                            img: personalization,
                            title: '个性化推送',
                            des: '用户点击转化率提升40%'
                        },
                        {
                            id: 3,
                            img: analysis,
                            title: '多维商品分析',
                            des: '实时监控热销品类与价格趋势'
                        }
                    ]
                }
            ],
            swiperOption: {
                name: "mySwiper",
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                }
                // autoplayDisableOnInteraction: false,
                // observeParents: true,
                // observer: true
            },
            showModal: false,
            modalData: {
                title: '商城入驻',
                phone: '',
                username: ''
            }
        }
    },
    created() {
    },
    methods: { 
        toOpen(type){
              let url = 'https://www.qixiubao.cn/static/QiXiuBaoInst.exe'
              switch (type) {
                  case 1:
                      url='https://www.qixiubao.cn/static/QiXiuBaoInst.exe'
                      onEventGsIdo('id2', '下载电脑客户端')
                      break;
                  case 2:
                      url='https://www.qixiubao.cn'
                      onEventGsIdo('id1', '免费体验')
                      break;
                  default:
                      url='https://www.qixiubao.cn/static/QiXiuBaoInst.exe'
                      onEventGsIdo('id2', '下载电脑客户端')
              }
              window.open(url)
        },
        toApply() {
            this.showModal = true
            console.log('toApply', this.showModal)
            onEventGsIdo('id3', '入驻申请')
        },
        async onConfirm() {
            onEventGsIdo('qxb_$submit_form', '提交表单')
            if(!this.modalData.phone) {
                onEventGsIdo('qxb_$submit_form_error', `提交表单失败-请输入联系方式！`)
                alert('请输入联系方式！')
                return
            }
            if(!this.modalData.username) {
                onEventGsIdo('qxb_$submit_form_error', `提交表单失败-请输入联系人！`)
                alert('请输入联系人！')
                return
            }
            const formData = new FormData();
            formData.append('title', this.modalData.title);
            formData.append('phone', this.modalData.phone);
            formData.append('username', this.modalData.username);
            try {
                const response = await fetch(`https://api.qixiubao.cn/api/?version=5.20.0.3&action=API.Article.addCooperate&title=${this.modalData.title}&username=${this.modalData.username}&phone=${this.modalData.phone}`, {
                    method: 'POST',
                    body: formData
                })
                if (!response.ok) {
                    throw new Error('网络响应失败');
                }

                const data = await response.json();
                if(data.code == 200) {
                    this.showModal = false
                    this.$message({
                        type: null,
                        title: '提交成功！',
                        position: 'center',
                        duration: 3000,
                        closable: true,
                        collapsable: false
                    })
                    onEventGsIdo('qxb_$submit_form_success', '提交表单成功')
                } else {
                    alert(data.message)
                    onEventGsIdo('qxb_$submit_form_error', `提交表单失败-${data.message}`)
                }
                console.log('请求成功:', data);
            } catch (error) {
                console.error('请求失败:', error);
            }
        },
        onCancel() {
            this.showModal = false
        }
    },
}
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
div {
    box-sizing: border-box;
}
.banner {
    .item {
        font-size: .px2vw(14)[@result];
        height: 25vw;
        // min-height: 330px;
        width: 100%;
        background-color: #ebf2fe;
        background-repeat: no-repeat;
        background-size: cover;
        .banner_button {
            box-sizing: content-box;
            height: .px2vw(48)[@result];
            line-height: .px2vw(48)[@result];
            display: flex;
            align-items: center;
            text-align: center;
            padding-top: 17.708333333333332vw;
            margin-left: 16.666666666666668vw;
            .free_experience {
                width: .px2vw(136)[@result];
                background: #165DFF;
                color: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                margin-right: .px2vw(16)[@result];
                cursor: pointer;
            }
            .win {
                width: .px2vw(166)[@result];
                display: flex;
                align-items: center;
                justify-content: center;
                color: #165DFF;
                border: 1px solid #165DFF;
                border-radius: 2px 2px 2px 2px;
                box-sizing: border-box;
                cursor: pointer;
                img {
                    width: .px2vw(20)[@result];
                    height: .px2vw(20)[@result];
                }
            }
        }
    }
    .functional {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: .px2vw(-32)[@result];
        margin-bottom: .px2vw(20)[@result];
        font-size: .px2vw(16)[@result];
        // .font-size(16, 12px);
        & > div {
            background: linear-gradient( 180deg, rgba(255,255,255,0.16) 1%, rgba(255,255,255,0.6) 14%, rgba(255,255,255,1) 30%, #FFFFFF 100%);
            box-shadow: 0px 7px 16px 0px rgba(225,229,238,0.3);
            border-radius: 6px 6px 6px 6px;
            border: 2px solid #FFFFFF;
            flex: 0 0 .px2vw(410)[@result];
            width: .px2vw(410)[@result];
            display: flex;
            padding: .px2vw(22)[@result] .px2vw(32)[@result];
            font-size: .px2vw(16)[@result];
            & > img {
                width: .px2vw(56)[@result];
                height: .px2vw(56)[@result];
            }
            & > div {
                margin-left: .px2vw(24)[@result];
            }
            .functional_title {
                font-weight: 700;
                font-size: .px2vw(16)[@result];
                // .font-size(16, 12px);
                line-height: .px2vw(24)[@result];
                margin-bottom: .px2vw(8)[@result];
            }
            .functional_des {
                font-weight: 400;
                font-size: .px2vw(14)[@result];
                // .font-size(14, 12px);
                line-height: .px2vw(22)[@result];
            }
        }
    }
    .form-group {
        label {
            font-weight: 700;
            font-size: 16px;
            margin-bottom: 16px;
            display: inline-block;
        }
        input {
            height: 48px;
            width: 100%;
            background: #ECEFF9;
            border-radius: 6px 6px 6px 6px;
            padding: 0 10px;
            margin-bottom: 32px;
            box-sizing: border-box;
        }
        select {
            height: 48px;
            width: 100%;
            background: #ECEFF9;
            border-radius: 6px 6px 6px 6px;
            padding: 0 30px 0 10px;
            margin-bottom: 32px;
            border: none;
            outline: 0;
        }
    }
}

.middle_m {
    margin: 0 .px2vw(24)[@result];
}
.functional_h5 {
    display: none;
}

@media screen and (max-width: 900px) {
  div {
    box-sizing: border-box;
  }
  .banner {
    .item {
        height: .h5px2vw(702)[@result];
        .banner_button {
            display: none;
        }
    }
    .functional {
        display: none;
    }
    .functional_h5 {
        display: flex;
        font-size: .h5px2vw(24)[@result];
        & > div {
            width: 33.3333%;
            text-align: center;
            padding: .h5px2vw(16)[@result] 0;
            img {
                width: .h5px2vw(48)[@result];
                height: .h5px2vw(48)[@result];
                margin-bottom: .h5px2vw(8)[@result];
            }
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/banner.vue